<template>
  <div id="app">
    <MenuNi :mobile="isMobile"></MenuNi>
    <About :mobile="isMobile" data-index="0" ref="steps" class="steps"></About>
    <Detalles :mobile="isMobile" :detalles="dataDetalles" v-if="abre" :esteId="esteId" @cerrarDetalles="botonCierra"></Detalles>
    <Works data-index="1" :seccs="seccs" :dataWorks="dataWorks" :skills="skills" ref="steps" class="steps" @abrirDetalles="abreDetail" @cambiaID="idDetail"></Works>
    <Illustra data-index="2" :dataIllus="dataIllus" ref="steps" class="steps" @abrirDetalles="abreDetail" @cambiaID="idDetail"></Illustra>
    <Contact data-index="3" ref="steps" class="steps"></Contact>
    <!-- <div class="scrollDown">
      <a href="#head">^</a>
    </div> -->
  </div>
</template>

<script>

// import 'intersection-observer'
import MenuNi from './components/MenuNi.vue'
import About from './components/About.vue'
import Works from './components/Works.vue'
import Illustra from './components/Illustra.vue'
import Contact from './components/Contact.vue'
import Detalles from './components/Detalles.vue'
import ScrollReveal from 'scrollreveal'
// import bucketImage from '@/mixins/bucketImage.js'
const sheetId = '14GVvcH7V2pUgXU1TvX-txpXS_jOA7C7igs9h0-X8LOI';
const base = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?`;
const sheetNameInfos = 'infos';
const sheetNameIllus = 'illus';
const sheetNameDetalles = 'detalles';
const query = encodeURIComponent('Select *')
const urlInfos = `${base}&sheet=${sheetNameInfos}&tq=${query}`
const urlIllus = `${base}&sheet=${sheetNameIllus}&tq=${query}`
const urlDetalles = `${base}&sheet=${sheetNameDetalles}&tq=${query}`

export default {
  name: 'app',
  data() {
    return {
      dataWorks: [],
      dataIllus: [],
      dataDetalles: [],
      secciones: [],
      seccs: [],
      skills: [],
      isMobile: false,
      prog: null,
      viejo: null,
      nuevo: null,
      activeIndex: -1,
      abre: false,
      esteId: null,
    }
  },
  // mixins: [bucketImage],
  components: {
    MenuNi,
    About,
    Works,
    Illustra,
    Contact,
    Detalles
  },
  created() {
    this.hideLoader()
    this.isMobile = window.innerWidth <= 500
    window.addEventListener(
      'resize',
      () => (this.isMobile = window.innerWidth <= 500),
    )
  },
  mounted() {
    this.fetchData()
    // this.initObserver();
    this.initScrollReveal();
    this.$nextTick(() => {
      // let steps = this.$refs.steps;
      let steps = document.querySelectorAll('[data-index]')
      // let stepsW = document.querySelectorAll('#works .step.stepLi')
      let arrSteps = Array.from(steps)
      // let arrStepsW = Array.from(stepsW)
      // console.log('ste', arrSteps);
      
      const observerAll = new IntersectionObserver(this.handleIntersect, {
        root: null, // Usa la ventana como contenedor
        threshold: 0.5, // El elemento es visible al 50%
      });

      if (Array.isArray(arrSteps)) {
        // console.log('ACA', arrSteps);
        arrSteps.forEach((step) => {
          if (step instanceof Element) {
            
            step.classList.add('active')
            observerAll.observe(step);
          } else {
            // console.warn('Un elemento no es válido para observar:', step);
          }
        });
      } else if (steps instanceof Element) {
        // console.log('ACA IF', steps);
        observerAll.observe(arrSteps);
      }
      // if (Array.isArray(arrStepsW)) {
      //   console.log('ES ARR', arrStepsW);
      //   arrStepsW.forEach((stepW) => {
      //     if (stepW instanceof Element) {
      //       observerW.observe(stepW);
            
      //       stepW.classList.add('active')
      //     } else {
      //       console.warn('Un elemento no es válido para observar:', stepW);
      //     }
      //   });
      // }
    });
  },
  computed: {},
  methods: {
    botonCierra(close){
      this.abre = close // manda false desde Detalles.vue
    },
    abreDetail(open){
      this.abre = open // manda true desde Works.vue
    },
    idDetail(id){
      // console.log('idDetail', id, this.esteId);
      this.esteId = id // manda true desde Works.vue
      // console.log('idDetaillll', id, this.esteId);
    },
    initScrollReveal() {
      // const sr = ScrollReveal();

      // // Define las opciones globales (opcional)
      // sr.reveal('.reveal-animation', {
      //   duration: 1000, // Duración de la animación
      //   distance: '50px', // Distancia de movimiento
      //   origin: 'bottom', // Origen de la animación (top, bottom, left, right)
      //   easing: 'ease-in-out', // Tipo de animación
      // });

      // // Aplica la animación a los elementos con la clase 'reveal-animation'
    //   const revealElements = document.querySelectorAll('.stepLi');
    //  console.log(revealElements);
     
      const scrollRev = ScrollReveal({
          distance: "70px",
          duration: 500,
          delay: 200,
          reset: false
      })

      // revealElements.forEach(element => {
      //   scrollRev.reveal(element);
      // });

      // scrollRev.reveal("#menu", {delay: 200, origin: "top", reset: false});
      // scrollRev.reveal("#head", {delay: 200, origin: "top", reset: false});
      scrollRev.reveal(".hero", {delay: 50, origin: "top"});
      scrollRev.reveal(".heroText", {delay: 250, origin: "top", reset: true});
      scrollRev.reveal(".heroImg", {delay: 350, origin: "top", reset: true});
      // scrollRev.reveal("#works", {delay: 50, origin: "top"});
      // scrollRev.reveal(".stepLi", {delay: 200, origin: "top"});
      scrollRev.reveal("#illus", {delay: 200, origin: "top"});
      scrollRev.reveal("#contact", {delay: 200, origin: "bottom"});
      // scrollRev.reveal(".icons", {delay: 500, origin: "left"});
      // scrollRev.reveal(".scrollDown", {delay: 450, origin: "right"});
      // scrollRev.reveal(".stepLi", {delay: 200, origin: "bottom"});
      

    },
    // initObserver() {
    //   const observer = new IntersectionObserver(this.handleIntersect, {
    //     root: null,
    //     threshold: 0.5,
    //   });

    //   // Recoger todas las referencias de pasos
    //   const stepElements = this.$refs.steps;

    //   if (Array.isArray(stepElements)) {
    //     stepElements.forEach((step) => {
    //       if (step instanceof Element) {
    //         observer.observe(step);
    //       } else {
    //         console.warn("Referencia no válida para observar:", step);
    //       }
    //     });
    //   } else if (stepElements instanceof Element) {
    //     observer.observe(stepElements);
    //   } else {
    //     console.warn("No se encontraron elementos válidos para observar.");
    //   }
    // },
    // handleIds(){
    //   let workFond = document.getElementById('works')
    //   let menuFond = document.getElementById('menu')
    //   workFond.style.backgroundColor = '#e2effb'
    //   menuFond.style.backgroundColor = '#e2effb'
    // },
    handleIntersect(entries) {
      // let workFond = document.getElementById('works')
      // console.log('LALALA',entries);
      
      entries.forEach((entry) => {
        // console.log(entry.isIntersecting, entry);
        if (entry.isIntersecting) {
          // console.log('ID', entry.target.id);
          
          // if(entry.target.id === 'titWork'){
          //   workFond.style.backgroundColor = '#e2effb'
          // }
          // Actualizar índice activo basado en el dataset del elemento
          this.activeIndex = parseInt(entry.target.dataset.index, 10);
          // console.log('Elemento visible:', entry.target.dataset.index);
        }
      });
    },
    
    hideLoader() {
      const $loader = document.getElementById('preload')
      if ($loader) $loader.style.display = 'none'
    },
    fetchData() {
      fetch(urlInfos)
        .then(res => res.text())
        .then(rep => {
          //Remove additional text and extract only JSON:
          const jsonData = JSON.parse(rep.substring(47).slice(0, -2));
          const rows = jsonData.table.rows;
          // console.log('I', jsonData);
          
          let infos = []
          rows.forEach((row) => {
            let valId = row.c[0].v;
            let valTitulo = row.c[1].v;
            let valBajada = row.c[2].v;
            let valSeccion = row.c[3].v;
            let valLink = row.c[4].v;
            let valImagen = row.c[5].v;
            let valSkills = row.c[6].v;
            let valAnio = row.c[7].v;
            let video = false
            if(valImagen.includes('.mp4')){
              video = true
            }
            let work = {
              id: valId,
              titulo: valTitulo,
              bajada: valBajada,
              seccion: valSeccion,
              link: valLink,
              imagen: valImagen,
              skills: valSkills,
              anio: valAnio,
              video,
            }
            infos.push(work)
        })
        this.dataWorks = infos

        this.getSecciones(infos)
      })
      fetch(urlIllus)
        .then(res => res.text())
        .then(rep => {
          //Remove additional text and extract only JSON:
          const jsonData = JSON.parse(rep.substring(47).slice(0, -2));
          const rows = jsonData.table.rows;
          // console.log('ill', jsonData);
          
          let illus = []
          rows.forEach((row) => {
            let valId = row.c[0].v;
            let valTitulo = row.c[1].v;
            let valBajada = row.c[2].v;
            let valImagen = row.c[3].v;
            let valSkills = row.c[4].v;
            let valAnio = row.c[5].v;
            let valLink = row.c[6].v;
            let video = false
            if(valImagen.includes('.mp4') || valImagen.includes('.gif')){
              video = true
            }
            
            let illu = {
              id: valId,
              titulo: valTitulo,
              bajada: valBajada,
              imagen: valImagen,
              skills: valSkills,
              anio: valAnio,
              link: valLink,
              video,
            }
            illus.push(illu)
        })
        this.dataIllus = illus
      })
      fetch(urlDetalles)
        .then(res => res.text())
        .then(rep => {
          //Remove additional text and extract only JSON:
          const jsonData = JSON.parse(rep.substring(47).slice(0, -2));
          const rows = jsonData.table.rows;
          
          let detalles = []
          rows.forEach((row) => {
            // console.log('I', row);
            let valId = row.c[0].v;
            let valTitulo = row.c[1].v;
            let valBajada = row.c[2].v;
            let valTexto = row.c[3].v;
            let valImagenes = row.c[4].v;
            let valBoton = row.c[5].v;
            let valLink = row.c[6].v;
            let valBoton2 = row.c[7].v;
            let valLink2 = row.c[8].v;
            let video = false
            if(valImagenes.includes('.mp4')){
              video = true
            }
            if(valTexto == null){
              valTexto = ""
            }
            if(valBoton2 == null){
              valBoton2 = ""
            }
            if(valLink2 == null){
              valLink2 = ""
            }
            let detail = {
              id: valId,
              titulo: valTitulo,
              bajada: valBajada,
              texto: valTexto,
              imagenes: valImagenes,
              boton: valBoton,
              link: valLink,
              boton2: valBoton2,
              link2: valLink2,
              video,
            }
            detalles.push(detail)
        })
        this.dataDetalles = detalles
        // console.log('LLL', detalles);

        // this.getSecciones(infos)
      })
    },
    getSecciones(infos) {
      let conComa
      infos.forEach((sec) => {
        conComa = sec.seccion.includes(',')
        if(conComa){
          let separado = sec.seccion.split(',')
          for (let i = 0; i < separado.length; i++) {
            let sinEsp = separado[i].trim()
            this.secciones.push(sinEsp)
          }
        } else {
          this.secciones.push(sec.seccion)
        }
      })
      this.seccs = [...new Set(this.secciones)]
    },
    
  },
  watch: {
    prog: function(newVal, oldVal) {
      this.nuevo = newVal
      this.viejo = oldVal
      
    },
    deep: true
  }
}
</script>

<style lang="scss">
@import '@/styles/_global.scss';

#app {
  background: #131313;
  .scrollDown{
    position: fixed;
    bottom: 6%;
    right: 4%;
    a{
      background-color: var(--black);
      // width: 30px;
      // height: 30px;
      border-radius: 30px;
      padding: 10px 15px;
      font-size: 23px;
      line-height: 23px;
      vertical-align: bottom;
      // display: block;
      color: var(--white);
      text-decoration: none;
      font-family:Verdana, Geneva, Tahoma, sans-serif;
      transition: all .5s ease;
      cursor: pointer;
      &:hover{
        transform: translateY(-7px);
        background-color: aqua;
        color: var(--black);
        // mix-blend-mode: difference;
      }
    }
  }
}
</style>
